<template>
  <div class="classify-base">
    <p v-for="(item ,index) in Classify" :key="index"
       @click="HandleClassify(index,item.name)"
       :class="{current: index == Current}"
    >{{item.name}}</p>
  </div>
</template>

<script>
  export default {
    name: "ContentClassify",
    data(){
      return{
        Classify:null,
        Current:0,
      }
    },
    methods:{
      GetLargeType(){
        this.$axios.get('/api/serveItem/getTypeList').then(res=>{
          this.Classify=res.data.data
        })
      },
      HandleClassify(index,name){
        this.Current=index
        this.$emit('code',name)
      },
      handleOrigin(name) {
        if(name == '媒体服务'){
          this.Current=2
        }
        if(name == '影音系统集成'){
          this.Current=0
        }
        if(name == '声像专业场所建设'){
          this.Current=1
        }
      }
    },
    created() {
      this.GetLargeType()
      this.handleOrigin(this.$route.params.name)
    },
    watch:{
      '$route.params.name'(name){
        if(name == '媒体服务'){
          this.Current=2
        }
        if(name == '影音系统集成'){
          this.Current=0
        }
        if(name == '声像专业场所建设'){
          this.Current=1
        }
      }
    }

  }
</script>

<style lang="less" scoped>
.classify-base{
  width: 168px;
  min-width: 140px;
  height: 210px;
  box-sizing: border-box;
  margin-right: 20px;
  background: #FFFFFF;
  border: 1px solid #DDDDDD;
  text-align: center;
  .current{
    color: #188ACB;
  }
  p{
    width: 100%;
    height: 70px;
    overflow: hidden;
    font-size: 16px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    line-height: 70px;
    cursor: pointer;
  }
}
</style>